possibleTypes